<template>
    <b-modal
            ref="modal"
            size="lg"
            :title="title"
            :visible="true"
            @hidden="$emit('hidden')"
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
    >
        <ValidationObserver ref="observer" tag="form" @submit.prevent="handleSubmit()" v-slot="{ invalid }">
            <b-form-row>
                <b-col sm="3" lg="2">
                    <label class="required">{{$t('email.email_address')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                        <ValidationProvider rules="email|required" v-slot="{ classes, errors }">
                            <input v-model="form.email" type="text" class="form-control" :class="classes">
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label class="required">{{$t('email.username')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                        <ValidationProvider rules="required" v-slot="{ classes, errors }">
                            <input v-model="form.config.username" class="form-control" :class="classes">
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <legend class="font-size-sm font-weight-bold">{{$t('email.inbox_settings_legend')}}</legend>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label>{{$t('email.protocol')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                        <b-form-radio-group
                                id="radio-inbox-protocol"
                                v-model="form.config.inbox.protocol"
                                :options="inboxProtocols"
                                plain
                        />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label class="required">{{$t('email.server_address')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                        <ValidationProvider rules="required" v-slot="{ classes, errors }">
                            <input v-model="form.config.inbox.host" class="form-control" :class="classes">
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label :class="emailUuid ? '' : 'required'">{{$t('email.password')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                        <ValidationProvider :rules="emailUuid ? '' : 'required'" v-slot="{ classes, errors }">
                            <input type="password" v-model="form.config.password" class="form-control" :class="classes">
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label class="required">{{$t('email.port')}}</label>
                </b-col>

                <b-col sm="3" lg="4">
                    <b-form-group>
                        <ValidationProvider rules="required" v-slot="{ classes, errors }">
                            <input type="number" v-model="form.config.inbox.port" class="form-control" :class="classes">
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label>{{$t('email.encryption')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                            <b-form-radio-group
                                    id="radio-inbox-ssl"
                                    v-model="form.config.inbox.ssl"
                                    :options="sslOptions"
                                    plain
                            />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <legend class="font-size-sm font-weight-bold">{{$t('email.outbox_settings_legend')}}</legend>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label class="required">{{$t('email.server_address')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                        <ValidationProvider rules="required" v-slot="{ classes, errors }">
                            <input v-model="form.config.outbox.host" class="form-control" :class="classes">
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label class="required">{{$t('email.port')}}</label>
                </b-col>

                <b-col sm="4" lg="3">
                    <b-form-group>
                        <ValidationProvider rules="required" v-slot="{ classes, errors }">
                            <input type="number" v-model="form.config.outbox.port" class="form-control"
                                   :class="classes">
                            <span class="invalid-feedback">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col sm="3" lg="2">
                    <label>{{$t('email.encryption')}}</label>
                </b-col>

                <b-col sm="7" lg="8">
                    <b-form-group>
                        <b-form-radio-group
                                id="radio-outbox-ssl"
                                v-model="form.config.outbox.ssl"
                                :options="sslOptions"
                                plain
                        />
                    </b-form-group>
                </b-col>
            </b-form-row>

            <div class="text-right">
                <button class="btn btn-link mr-2" @click.prevent="closeModal()" :disabled="busy">{{$t('_cancel')}}</button>
                <b-button variant="primary" size="sm" @click.prevent="handleSubmit" :disabled="busy">
                    <fa-icon v-if="busy" icon="spinner" spin />
                    <span v-else>{{ emailUuid ? $t('_save') : $t('email.add_email_account_button') }}</span>
                </b-button>
            </div>

        </ValidationObserver>

    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import {ValidationObserver, ValidationProvider, configure, extend} from 'vee-validate';
    import {required, email} from 'vee-validate/dist/rules';
    import i18n from "@/i18n";
    extend('email', {
        ...email,
        message: i18n.t('email.provide_correct_email_validation')
    });

    extend('required', {
        ...required,
        message: i18n.t('email.this_field_is_required')
    });

    configure({
        classes: {
            valid: 'is-valid',
            invalid: 'is-invalid'
        }
    });

    export default {
        name: "EmailsModal",
        components: {ValidationProvider, ValidationObserver},
        props: {
            emailUuid: {
                type: String,
                required: false,
            }
        },

        data() {
            return {
                formState: null,
                busy: false,

                form: {
                    email: '',
                    config: {
                        username: '',
                        password: '',
                        inbox: {
                            host: '',
                            port: 143,
                            protocol: 'IMAP',
                            ssl: 'NONE'
                        },
                        outbox: {
                            host: '',
                            port: 25,
                            protocol: 'SMTP',
                            ssl: 'NONE'
                        }
                    },
                },

                inboxProtocols: ['IMAP'],
                sslOptions: [
                    { text: 'Brak', value: 'NONE' },
                    { text: 'STARTTLS', value: 'STARTTLS' },
                    { text: 'SSL/TLS', value: 'SSL/TLS' },
                ],
            }
        },

        methods: {
            closeModal() {
                this.$refs['modal'].hide()
            },
            async handleSubmit() {
                const valid = await this.$refs.observer.validate();
                if (!valid || this.busy) {
                    return
                }
                this.busy = true;
                this.$store
                    .dispatch('Email/updateAccount', {account: this.form, uuid: this.emailUuid})
                    .then(() => this.closeModal())
                    .finally(() => this.busy = false);
            },
            getConfiguration(emailUuid) {
                this.busy = true;
                return this.$store.dispatch('Email/fetchConfig', emailUuid)
                    .then(({data}) => {
                        this.form = {
                            email: data.data.email,
                            footer: data.data.footer,
                            config: data.data.config,
                        }
                    })
                    .finally(() => this.busy = false)
            }
        },

        created() {
            if (this.emailUuid) {
                this.getConfiguration(this.emailUuid);
            }
        },

        computed: {
            title() {
                return this.emailUuid ? this.$t('email.email_edit_title') : this.$t('email.email_add_title');
            },

            ...mapGetters('Email', ['config'])
        },
    }
</script>

<style scoped lang="scss">
    label.required::after {
        content: '*';
        color: red;
        padding-left: 5px;
    }
</style>